import React from "react";
import styles from "./WizardProgress.module.css";

type WizardProgressProps = {
  max: number;
  value: number;
};

const WizardProgress: React.FC<WizardProgressProps> = ({ max, value }) => (
  <div className={styles.progressWrap}>
    <progress className={styles.progress} max={max} value={value} />
  </div>
);

export default WizardProgress;
